import { PermissionRequirement } from './permission.model';

/** Permisos tenant resource `accounts` (paridad Rails). */
export const FINANCE_ACCOUNT_PERMISSIONS = {
  list: { resource: 'accounts', action: 'index' },
  show: { resource: 'accounts', action: 'show' },
  create: { resource: 'accounts', action: 'create' },
  update: { resource: 'accounts', action: 'update' },
  destroy: { resource: 'accounts', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;

/** Permisos tenant resource `categories` (categorías financieras, paridad Rails). */
export const FINANCE_CATEGORY_PERMISSIONS = {
  list: { resource: 'categories', action: 'index' },
  show: { resource: 'categories', action: 'show' },
  create: { resource: 'categories', action: 'create' },
  update: { resource: 'categories', action: 'update' },
  destroy: { resource: 'categories', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;

/** Permisos tenant resource `transactions` (ingresos/egresos). */
export const FINANCE_TRANSACTION_PERMISSIONS = {
  list: { resource: 'transactions', action: 'index' },
  show: { resource: 'transactions', action: 'show' },
  create: { resource: 'transactions', action: 'create' },
  update: { resource: 'transactions', action: 'update' },
  destroy: { resource: 'transactions', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;

/** Permisos tenant resource `transfers`. */
export const FINANCE_TRANSFER_PERMISSIONS = {
  list: { resource: 'transfers', action: 'index' },
  show: { resource: 'transfers', action: 'show' },
  create: { resource: 'transfers', action: 'create' },
  update: { resource: 'transfers', action: 'update' },
  destroy: { resource: 'transfers', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;

/** Permisos tenant resource `cash_counter` (contador de efectivo, paridad Rails). */
export const FINANCE_CASH_COUNTER_PERMISSIONS = {
  show: { resource: 'cash_counter', action: 'show' },
} as const satisfies Record<string, PermissionRequirement>;

/** Permisos tenant resource `credits` (créditos/abonos de empleados, paridad Rails). */
export const FINANCE_CREDIT_PERMISSIONS = {
  list: { resource: 'credits', action: 'index' },
  show: { resource: 'credits', action: 'show' },
  create: { resource: 'credits', action: 'create' },
  update: { resource: 'credits', action: 'update' },
  destroy: { resource: 'credits', action: 'destroy' },
} as const satisfies Record<string, PermissionRequirement>;
